export const IS_DEV = process.env.REACT_APP_IS_DEV === 'true'
export const API_URL = process.env.REACT_APP_API_URL || ''
export const ACC_KEY = process.env.REACT_APP_ACC_KEY || ''
export const SIDEBYSIDE_API_URL = process.env.REACT_APP_SIDEBYSIDE_API_URL || ''
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || ''
